import { CollapsibleSection } from "components/designV2/collapsibleSection/collapsibleSection";
import { useTranslation } from "react-i18next";
import { type CompanyGigApplications } from "model/Gig";
import { TeamPublicDetailsModalApplicationRow } from "./teamPublicDetailsModal.applicationRow.component";
import {
  ApplicationsList,
  EmployeesCountText,
} from "./teamPublicDetailsModal.styled";
import { DetailsMessage } from "../shiftDetailsModal.styled";

interface TeamPublicDetailsModalEmployeesSectionProps {
  hiredApplications: ReadonlyArray<CompanyGigApplications>;
  amountOfWorkers: number;
  avatarUrls: Record<string, string>;
  onOpenMotivationalLetterModal: (motivationalLetter: string) => void;
}

export const TeamPublicDetailsModalEmployeesSection: React.FC<
  TeamPublicDetailsModalEmployeesSectionProps
> = (props) => {
  const { t } = useTranslation();
  const hiredCount = props.hiredApplications.length;
  const hasHiredApplications = hiredCount > 0;
  const safeAmountOfWorkers = Number.isFinite(props.amountOfWorkers)
    ? Math.max(0, props.amountOfWorkers)
    : 0;

  return (
    <CollapsibleSection
      label={t("Schedule.TeamPublicEmployees")}
      defaultOpen={hasHiredApplications}
      headerRight={
        <EmployeesCountText>{`(${hiredCount}/${safeAmountOfWorkers})`}</EmployeesCountText>
      }
    >
      {!hasHiredApplications ? (
        <DetailsMessage>{t("Schedule.TeamPublicNoEmployees")}</DetailsMessage>
      ) : (
        <ApplicationsList>
          {props.hiredApplications.map((application) => (
            <TeamPublicDetailsModalApplicationRow
              key={`hired-${application.id}`}
              application={application}
              avatarUrl={props.avatarUrls[application.worker.externalId]}
              isBusy={false}
              canManageApplication={false}
              onOpenMotivationalLetterModal={
                props.onOpenMotivationalLetterModal
              }
            />
          ))}
        </ApplicationsList>
      )}
    </CollapsibleSection>
  );
};
